import type { ElementState, AlertingState, singleElementState } from "@/types";

import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";
import type { EventListState, AlertListState } from "@/types/store";

const elementSate: ElementState<any> = {
  data: [],
  error: null,
  loading: false,
};

const singleElementSate: singleElementState<any> = {
  data: [],
  error: null,
  loading: false,
};

const eventListState: EventListState = {
  data: [],
  error: null,
  loading: false,
  count: 0,
};

const AlertListState: AlertListState = {
  data: [],
  error: null,
  loading: false,
  count: 0,
};

export const alertingState: AlertingState = {
  alerts: AlertListState,
  alertsExport: singleElementSate,
  projectAlerts: AlertListState,
  projectVariables: elementSate,
  alertsTypes: elementSate,
  alertsLevels: elementSate,
  scenarios: elementSate,
  events: eventListState,
  eventsExport: singleElementSate,
  alertScenarios: elementSate,
  event: singleElementSate,
  newScenario: singleElementSate,
  comments: elementSate,
  variableDatas: elementSate,
  diagnosticData: elementSate,
};

export const AlertingModule = {
  namespaced: true,
  state: alertingState,
  actions,
  mutations,
  getters,
};
